import React from 'react';
import Divider from "@material-ui/core/Divider";
import {Field, Formik} from "formik";
import TextField from "../../../components/Ui/TextField";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import {useDispatch} from "react-redux";
import axios from "axios";
import {OTHER_UPDATE_USER_PASSWORD, UPDATE_USER_INFOS} from "../../../api/Api";
import {actions as authActions} from "../../../modules/Auth/_redux/authRedux";
import * as Yup from "yup";
import {toast} from 'react-toastify';


export default function PasswordUpdatePage(props){

    const dispatcher = useDispatch()

    const [updateError,setUpdateError] = React.useState();

    async function updatePassword(values,formikHelpers){

        setUpdateError()

        try {

            console.log(formikHelpers)

            const response = await axios.patch(OTHER_UPDATE_USER_PASSWORD,values);

            // dispatcher(authActions.login(response.data.token))

            formikHelpers.resetForm();

            toast.success("Modification enregistré avec succès", {
                position: toast.POSITION.BOTTOM_LEFT,
                autoClose: 5000
            });

            console.log(response);

        } catch (e) {
            setUpdateError(e.response)
        } finally {
            formikHelpers.setSubmitting(false)
        }


    }

    return (
        <div className={''}>

            <div className={'text-right'}>
                <div className={'d-inline-block text-left'}>

                    <div className="h3 text-primary font-weight-bold">
                        Mot de passe
                    </div>
                    <div className={'small'}>
                        Modification de votre mot de passe
                    </div>
                </div>
                <Divider />

            </div>

            <div>

                <Formik
                    onSubmit={updatePassword}
                    validationSchema={Yup.object().shape({
                        oldPassword: Yup.string().required('Champs obligatoire'),
                        newPassword:  Yup.string().required(
                            "Champs obligatoire"
                        ).matches(
                                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&"'()§^:;,])[A-Za-z\d@$!%*#?&"'()§^:;,]{8,}$/,
                                "Le mot de passe doit contenir au moins 8 caractères, et au moins une majuscule, une minuscule , un chiffre et un symbole"
                            ),
                        newPasswordConfirmation: Yup.string()
                            .required(
                                "Champs obligatoire"
                            )
                            .when("password", {
                                is: (val) => (val && val.length > 0 ? true : false),
                                then: Yup.string().oneOf(
                                    [Yup.ref("newPassword")],
                                    "Les mots de passe ne correspondent pas"
                                ),
                            })

                    })}
                    initialValues={{
                        oldPassword: '',
                        newPassword: '',
                        newPasswordConfirmation: '',
                    }}
                >

                    {
                        (formikHelpers) => {

                            return (
                                <div className={'row'}>

                                    <div className="col-12 my-3">

                                        <Field
                                            component={TextField}
                                            label={'Ancien mot de passe'}
                                            name={'oldPassword'}
                                            type={'password'}
                                        />

                                        {
                                            updateError && updateError.status == 400 && (
                                                <div className="font-weight-bold text-danger small">
                                                    L'ancien mot de passe est incorrecte
                                                </div>
                                            )
                                        }

                                    </div>
                                    <div className="col-12 my-3">

                                        <Field
                                            component={TextField}
                                            label={'Nouveau mot de passe'}
                                            name={'newPassword'}
                                            type={'password'}
                                        />

                                    </div>

                                    <div className="col-12 my-3">

                                        <Field
                                            component={TextField}
                                            label={'Confirmation du nouveau mot de passe'}
                                            name={'newPasswordConfirmation'}
                                            type={'password'}
                                        />

                                    </div>

                                    <div className="col-12 mx-3 text-right mt-lg-20">

                                        <BootstrapLoadingButton onClick={formikHelpers.submitForm} className={'d-inline-block btn btn-light-primary'}>
                                            Modifiez votre mot de passe
                                        </BootstrapLoadingButton>

                                    </div>


                                </div>
                            );

                        }
                    }

                </Formik>

            </div>

        </div>
    );
}